import React, { useState } from 'react';
import Sidebar from './sidebar/Sidebar';
import Main from './main/Main';

const Dashboard = () => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);

  return (
    <div className='flex mt-16 h-screen bg-white dark:bg-slate-900'>
      {/* Sidebar section */}
      <section className={`${isSidebarExpanded ? 'w-60' : 'w-16'} transition-width duration-300`}>
        <Sidebar isExpanded={isSidebarExpanded} setIsExpanded={setIsSidebarExpanded} />
      </section>

      {/* Main content section */}
      <section className='flex-1 overflow-auto'>
        <Main />
      </section>
    </div>
  );
};

export default Dashboard;
